import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import Breadcrumb from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.breadcrumb,
});

export default withRouter(connect(mapStateToProps)(Breadcrumb));
